import { Component } from '@verndale/core';

class NearbyLinks extends Component {
  private expanded: boolean;

  constructor(el: HTMLElement) {
    super(el);
    this.expanded = false;

    this.checkLinks();
  }

  setupDefaults() {
    this.dom = {
      list: this.el.querySelector('.nearby-links__list') as HTMLUListElement,
      button: this.el.querySelector(
        '.nearby-links__button'
      ) as HTMLButtonElement,
      links: this.el.querySelectorAll('.nearby-links__item')
    };
  }

  addListeners() {
    (this.dom.button as HTMLButtonElement).addEventListener(
      'click',
      this.handleButtonClick.bind(this)
    );
  }

  checkLinks() {
    const links = this.dom.links as NodeListOf<HTMLAnchorElement>;

    if (links.length <= 7) {
      const button = this.dom.button as HTMLButtonElement;
      button.style.display = 'none';
    }
  }

  handleButtonClick() {
    const button = this.dom.button as HTMLButtonElement;
    const list = this.dom.list as HTMLUListElement;

    if (this.expanded) {
      list.classList.remove('nearby-links__list--expanded');
      button.classList.remove('nearby-links__button--less');
      button.classList.add('nearby-links__button--all');
      button.innerHTML = button.dataset.viewAll as string;
    } else {
      list.classList.add('nearby-links__list--expanded');
      button.classList.remove('nearby-links__button--all');
      button.classList.add('nearby-links__button--less');
      button.innerHTML = button.dataset.viewLess as string;
    }

    this.expanded = !this.expanded;
  }
}

export default NearbyLinks;
